import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { handleLogout } from "../helpers/handleLogout";

import jwt_decode from "jwt-decode";
const timeNow = Date.now() / 1000;

export const PrivateRoute = ({ userInfo, logoutUser }) => {
  const location = useLocation();
  let search = location.search;

  console.log({ userInfo, search });
  const navigate = useNavigate();
  let isAuthenticated = false;
  const token = userInfo;
  if (token) {
    try {
      const { _id: userID, exp: tokenExpiresAt } = jwt_decode(token);
      console.log(
        "jwt_decode",
        userID,
        "jwt_decode.exp * 1000 < new Date().getTime()",
        tokenExpiresAt < timeNow
      );
      if (!userID || tokenExpiresAt < timeNow) {
        handleLogout(logoutUser, navigate);
      } else {
        isAuthenticated = true;
      }
    } catch (error) {
      handleLogout(logoutUser, navigate);
    }
  }

  // console.log({ data })
  // if (data?.status === 'active' && data?.hasProfile === true) {
  //   navigate('/dashboard')
  // } else {
  //   navigate('/dashboard/personal-information')
  // }

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace search={search} state={{ from: location }} />
  );
};
